module.exports = __webpack_public_path__ + "img/error-page-content.eea27fde.svg";